import { keepPreviousData } from "@tanstack/react-query";

import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { fetchSearch } from "#modules/search/infra/search.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";
import { SearchEntity } from "shared";

export const searchResultsQuery = ({
  query,
  entity,
  page,
}: {
  query: string;
  entity?: SearchEntity;
  page: number;
}) => ({
  queryKey: queryKeys.search.results(query, entity, page),
  queryFn: () => fetchSearch({ query, entity, page }),
  placeholderData: keepPreviousData,
  staleTime: STALE_TIME,
  enabled: query.length > 0,
});
